import { render, staticRenderFns } from "./CreateEdit.html?vue&type=template&id=89727c80&scoped=true&"
import script from "./CreateEdit.vue?vue&type=script&lang=ts&"
export * from "./CreateEdit.vue?vue&type=script&lang=ts&"
import style0 from "./CreateEdit.vue?vue&type=style&index=0&id=89727c80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89727c80",
  null
  
)

export default component.exports